module.exports = __webpack_public_path__ + "logo-blue-new.png?91d8c66e45ff1ce8449bf810b8c22350";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-blue-new.png
// module id = 991
// module chunks = 0